import { call, put, takeEvery } from "redux-saga/effects"

import { GET_ALL_BOOKINGS, GET_BOOKING_BY_BOOKING_NO, GET_BOOKING_BY_CONTAINER_WISE, TRACK_BOOKING } from "./actionTypes"

import { getAllBookingFail, getAllBookingSuccess, getBookingBYContainerWiseFail, getBookingBYContainerWiseSuccess, getByBookingNoFail, getByBookingNoProgress, getByBookingNoSuccess, trackBookingFail, trackBookingSuccess } from "./actions"

import { getAllBookings, trackBooking, getByBookingNo, getBYBookingContainerWise } from "../../../helpers/backend_helper"

//Get All Bookings
function* fetchBookings() {
  try {
    const response = yield call(getAllBookings)
    yield put(getAllBookingSuccess(response))
  } catch (error) {
    yield put(getAllBookingFail(error))
  }
}
function* BookingsSaga() {
  yield takeEvery(GET_ALL_BOOKINGS, fetchBookings)
}
export default BookingsSaga

//track bookinh
function* track({ payload: containerNumber }) {
  try {
    const response = yield call(trackBooking, containerNumber)
    yield put(trackBookingSuccess(response))
  } catch (error) {
    yield put(trackBookingFail(error))
  }
}
export function* TrackBookingsSaga() {
  yield takeEvery(TRACK_BOOKING, track)
}

//track by booking no
function* getBookingByNo({ payload: trackId }) {
  try {
    yield put(getByBookingNoProgress())
    const response = yield call(getByBookingNo, trackId)
    yield put(getByBookingNoSuccess(response))
  } catch (error) {
    yield put(getByBookingNoFail(error))
  }
}
export function* GetByBookingNoSaga() {
  yield takeEvery(GET_BOOKING_BY_BOOKING_NO, getBookingByNo)
}

//track booking by container wise
function* getBookingBYContainerWise({ payload: { trackId, containerId } }) {
  try {
    const response = yield call(getBYBookingContainerWise, trackId, containerId);
    yield put(getBookingBYContainerWiseSuccess(response))
  } catch (error) {
    yield put(getBookingBYContainerWiseFail(error))
  }
}
export function* GetBookingBYContainerWiseSaga() {
  yield takeEvery(GET_BOOKING_BY_CONTAINER_WISE, getBookingBYContainerWise)
}